import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Title, ItemWrapper, Item } from './DiscoverInsightList.styles.js';

const DiscoverInsightList = (props) => {
    const { title, subTitle, titleLink, items } = props;
    return (jsxs(Fragment, { children: [jsx(Title, { title: title, subTitle: subTitle, titleLink: titleLink }), jsx(ItemWrapper, Object.assign({ "data-testid": "discovery-insight-list" }, { children: items.map(item => (jsx(Item, Object.assign({}, item), item.id))) }))] }));
};

export { DiscoverInsightList as default };
